import Plugin from '../Plugin'

export default class Notifications extends Plugin {

    constructor(network) {
        super(network)
        this.events = {
            'system_notice': this.systemNotice.bind(this)
        }
    }

    systemNotice(args = {}) {
        const message = typeof args.message === 'string' && args.message.trim().length > 0
            ? args.message.trim()
            : null

        if (!message) {
            return
        }

        const title = typeof args.title === 'string' && args.title.trim().length > 0
            ? args.title.trim()
            : null

        const level = typeof args.level === 'string'
            ? args.level.toLowerCase()
            : 'info'

        const buttonText = typeof args.buttonText === 'string' && args.buttonText.trim().length > 0
            ? args.buttonText.trim()
            : 'Okay'

        const layout = args.layout === 'dual' ? 'dual' : 'single'

        if (level === 'error' || level === 'warning') {
            this.interface.prompt.showError(message, buttonText)
            return
        }

        const text = title ? `${title}\n${message}` : message
        this.interface.prompt.showWindow(text, layout)
    }

}
